import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Check } from "lucide-react";
import Reveal from "./Reveal";

const SOLUTION_IMG = "/solution-boardroom.png";

export default function Solution() {
  const { t } = useLang();

  return (
    <section id="solution" data-testid="solution-section" className="py-24 md:py-32 bg-white">
      <div className="sap-container">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          {/* Image */}
          <Reveal className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div
                className="absolute -top-4 -left-4 w-24 h-24 border-l border-t"
                style={{ borderColor: "var(--sap-gold)" }}
              />
              <div
                className="absolute -bottom-4 -right-4 w-24 h-24 border-r border-b"
                style={{ borderColor: "var(--sap-gold)" }}
              />
              <img
                src={SOLUTION_IMG}
                alt="Executivos Sapientia discutindo dashboards e processos"
                loading="lazy"
                className="w-full h-[520px] object-cover"
              />
            </div>
          </Reveal>

          {/* Text */}
          <div className="lg:col-span-6 order-1 lg:order-2">
            <Reveal>
              <div className="flex items-center gap-3 mb-6">
                <span className="sap-divider-gold" />
                <span className="sap-overline">{t.solution.overline}</span>
              </div>
            </Reveal>
            <Reveal delay={80}>
              <h2
                className="font-serif leading-[1.1] tracking-tight"
                style={{
                  fontSize: "clamp(1.9rem, 3.4vw, 3rem)",
                  color: "var(--sap-navy)",
                  fontWeight: 400,
                }}
              >
                {t.solution.title}
              </h2>
            </Reveal>
            <Reveal delay={160}>
              <p className="mt-8 text-lg leading-relaxed text-neutral-600">
                {t.solution.body_1}
              </p>
            </Reveal>
            <Reveal delay={220}>
              <p className="mt-4 text-lg leading-relaxed text-neutral-600">
                {t.solution.body_2}
              </p>
            </Reveal>

            <Reveal delay={320}>
              <ul className="mt-10 space-y-4">
                {t.solution.bullets.map((b, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span
                      className="inline-flex items-center justify-center w-6 h-6 mt-0.5 shrink-0"
                      style={{
                        border: "1px solid var(--sap-gold)",
                        color: "var(--sap-gold)",
                      }}
                    >
                      <Check size={14} strokeWidth={2} />
                    </span>
                    <span className="text-[15px] text-[color:var(--sap-navy)]">{b}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
